import React from 'react'


function Bulb(props) {


    return (

<div>
 
    <div class="bulbimgtop" id="{props.bulbInfo.id}">
    <img className="fluid" src={props.bulbInfo.imgUrl}></img>
    {/* <p>{props.bulbInfo.number}</p> */}
    <p>{props.bulbInfo.textdisplay}</p>
  
    
    </div>
    
</div>
    )
}

export default Bulb